import React, {Component} from 'react'
import {Image, GridRow, GridColumn, Grid, Dropdown} from 'semantic-ui-react'

class QbDesktopData extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {accountOptions: [], data: [], name: null}
  }

  componentDidMount = () => {
    const {account} = this.props
    if (account.qbDesktopData != null) {
      let data = JSON.parse(account.qbDesktopData)
      if (!Array.isArray(data)) {
        data['account'] = 'DUMMY'
        data = [data]
      }
      let accounts = data.map(row => row['account'].toUpperCase())
      let accountOptions = accounts.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })).map((x) => {return {key: x, text: x, value: x}})
      let name = accounts.includes(account.quickbooksAccountName) ? account.quickbooksAccountName : accounts.includes(account.quickbooksAccountName.split(":")[1]) ? account.quickbooksAccountName.split(":")[1] :accountOptions[0].value
      this.setState({data, accountOptions, name})
    }
  }

  nameOnChange = (event, {value}) => {
    this.setState({name: value})
  }

  render() {
    let {data, accountOptions, name} = this.state
    let row = data.find(x => x['account'].toUpperCase() == name)
    if (row == null) return null
    return (
      <div style={{paddingBottom: '40px', border: '1px solid rgb(238,238,238)', padding: '25px', borderRadius: '10px', marginBottom: '25px'}}>
        <h3 style={{borderBottom: '1px solid rgb(238,238,238)', marginLeft: '-25px', marginRight: '-25px', paddingLeft: '25px', paddingBottom: '25px'}}>QB Desktop Data &nbsp;&nbsp;&nbsp;&nbsp; <small style={{fontWeight: 'lighter'}}>(View Only)</small></h3>

        {name != 'DUMMY' ?
          <React.Fragment>
            <div style={{paddingBottom: '10px'}}>
              <Image src='https://erp-rails-usa-production.s3.amazonaws.com/images/qb_logo.png' avatar />
              <span style={{color: 'rgb(200,200,200)', fontWeight: 'bold'}}>Account</span>

              &nbsp;&nbsp;&nbsp;&nbsp;({accountOptions.length} account option{accountOptions.length == 1 ? '' : 's'})
            </div>

            <Dropdown style={{marginBottom: '25px'}}
              placeholder='Select Account'
              fluid
              selection
              value={name}
              options={accountOptions}
              onChange={this.nameOnChange}
            />
          </React.Fragment>
        : null}


        <Grid columns={2} stackable>
          <GridRow>
            <GridColumn>
              <div style={{paddingBottom: '10px'}}>
                <Image src='https://erp-rails-usa-production.s3.amazonaws.com/images/qb_logo.png' avatar />
                <span style={{color: 'rgb(200,200,200)', fontWeight: 'bold'}}>Main Phone</span>
              </div>
              <textarea style={{padding: '10px', width: '100%', height: '50px', verticalAlign: 'top', background: 'white', resize: 'none'}} disabled value={row["main_phone"]}></textarea>
            </GridColumn>
            <GridColumn>
              <div style={{paddingBottom: '10px'}}>
                <Image src='https://erp-rails-usa-production.s3.amazonaws.com/images/qb_logo.png' avatar />
                <span style={{color: 'rgb(200,200,200)', fontWeight: 'bold'}}>Main Email</span>
              </div>
              <textarea style={{padding: '10px', width: '100%', height: '50px', verticalAlign: 'top', background: 'white', resize: 'none'}} disabled value={row["main_email"]}></textarea>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn>
              <div style={{paddingBottom: '10px'}}>
                <Image src='https://erp-rails-usa-production.s3.amazonaws.com/images/qb_logo.png' avatar />
                <span style={{color: 'rgb(200,200,200)', fontWeight: 'bold'}}>Bill To</span>
              </div>
              <textarea style={{padding: '10px', width: '100%', height: '120px', verticalAlign: 'top', background: 'white', resize: 'none'}} disabled value={row["bill_to"]}></textarea>

            </GridColumn>
            <GridColumn>
              <div style={{paddingBottom: '10px'}}>
                <Image src='https://erp-rails-usa-production.s3.amazonaws.com/images/qb_logo.png' avatar />
                <span style={{color: 'rgb(200,200,200)', fontWeight: 'bold'}}>Ship To</span>
              </div>
              <textarea style={{padding: '10px', width: '100%', height: '120px', verticalAlign: 'top', background: 'white', resize: 'none'}} disabled value={row["ship_to"]}></textarea>

            </GridColumn>
          </GridRow>
        </Grid>

      </div>
    )
  }
}

export default QbDesktopData
